import { CURRENT_YEAR } from '../constants/currentYear';
export const COPYRIGHT = `АО «АС Рус Медиа» · ${CURRENT_YEAR}`;
